const RESPONSE_EVENT = "citibot-response-completed";

export function announceResponse(html) {
  const content = document.createElement("div");
  content.innerHTML = html;
  content.querySelectorAll("script, style").forEach((node) => node.remove());
  content
    .querySelectorAll("br, p, div, li, h1, h2, h3, h4, h5, h6")
    .forEach((node) => node.append(document.createTextNode(" ")));
  const text = content.textContent.replace(/\s+/g, " ").trim();
  if (text) {
    window.dispatchEvent(new CustomEvent(RESPONSE_EVENT, { detail: text }));
  }
}

export function connectResponseAnnouncer(region) {
  let pending = [];
  let timer;
  const onResponse = ({ detail }) => {
    pending.push(detail);
    // Clear separately so identical consecutive replies announce again.
    region.textContent = "";
    clearTimeout(timer);
    timer = setTimeout(() => {
      // Preserve both a reply and its immediate follow-up.
      region.textContent = pending.join("\n");
      pending = [];
    }, 100);
  };
  window.addEventListener(RESPONSE_EVENT, onResponse);
  return () => {
    window.removeEventListener(RESPONSE_EVENT, onResponse);
    clearTimeout(timer);
    region.textContent = "";
  };
}

// The widget marks its entire conversation as live. Only our completed-response
// announcer should speak updates; history remains available for manual reading.
export function silenceTranscriptAnnouncements(root) {
  const silence = () => {
    root
      .querySelectorAll(".rcw-conversation-container")
      .forEach((container) => {
        if (container.getAttribute("aria-live") !== "off") {
          container.setAttribute("aria-live", "off");
        }
      });
  };
  silence();
  const observer = new MutationObserver(silence);
  observer.observe(root, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ["aria-live"],
  });
  return () => observer.disconnect();
}
